var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-view',[_c('o-nav-bar',{attrs:{"title":"Ticket","has-close-button":true}}),_c('o-section',[_c('o-reseller-badge')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }